var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOfferIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.16138L20.75 7.53638V16.4634L12 20.8384L3.25 16.4634V7.53638L12 3.16138ZM9.7206 5.97813L16.0107 8.9266L18.2324 7.95461L12 4.83843L9.7206 5.97813ZM19.25 9.14666L12.75 11.9904V18.7864L19.25 15.5364V9.14666ZM11.25 18.7864V11.9904L4.75 9.14666V15.5364L11.25 18.7864ZM5.76764 7.95461L12 10.6813L14.1827 9.72634L8.01055 6.83316L5.76764 7.95461Z",
    fill: "#9799B5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferIcon);
export default __webpack_public_path__ + "static/media/offer-icon.6ff3079024f60c325470ae50afd4f0dd.svg";
export { ForwardRef as ReactComponent };